"use strict";
var _a, _b, _c, _d;
(_a = document.getElementById("forgot-btn")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function () {
    var _a, _b, _c, _d;
    (_a = document.getElementById("reset-form")) === null || _a === void 0 ? void 0 : _a.classList.toggle("d-none");
    (_b = document.getElementById("login-form")) === null || _b === void 0 ? void 0 : _b.classList.toggle("d-none");
    (_c = document.getElementById("login-title")) === null || _c === void 0 ? void 0 : _c.classList.toggle("d-none");
    (_d = document.getElementById("reset-title")) === null || _d === void 0 ? void 0 : _d.classList.toggle("d-none");
});
(_b = document.getElementById("show-login-form")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", function () {
    var _a, _b, _c, _d;
    (_a = document.getElementById("reset-form")) === null || _a === void 0 ? void 0 : _a.classList.toggle("d-none");
    (_b = document.getElementById("login-form")) === null || _b === void 0 ? void 0 : _b.classList.toggle("d-none");
    (_c = document.getElementById("login-title")) === null || _c === void 0 ? void 0 : _c.classList.toggle("d-none");
    (_d = document.getElementById("reset-title")) === null || _d === void 0 ? void 0 : _d.classList.toggle("d-none");
});
var resetPasswordBlock = document.querySelector("#reset-form .success-sent-password-reset");
if (resetPasswordBlock) {
    (_c = document.getElementById("reset-form")) === null || _c === void 0 ? void 0 : _c.classList.toggle("d-none");
    (_d = document.getElementById("login-form")) === null || _d === void 0 ? void 0 : _d.classList.toggle("d-none");
}
